import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'
import styles from './Hero.css'
import moment from 'moment'
import {FrameAnimation, LIB} from '../../constants/consts-types'
import {TypeListItem, TypeRoute} from '../../constants/consts-prop-types'
import {getViewPortHeight, getViewPortWidth, isDesktop, isSMKGuide} from '../../services/service-utils'
import DescriptionListsContainer from '../DescriptionLists/DescriptionListsContainer'
import RichText from '../RichText/RichText'
import {loadImage} from '../../services/service-image-loader'
import CategoryOrSubBrand from './partials/CategoryOrSubBrand'
import HeaderBoldLightSub from './partials/HeaderBoldLightSub'
import CTAs from './partials/CTAs'
import HeroVideoPlayer from "./partials/HeroVideoPlayer";

class HeroArticle extends Component {
  static propTypes = {
    data: TypeListItem,
    currentRoute: TypeRoute,
  }

  constructor(props) {
    super(props)

    this.state = {
      loadingImage: true,
      imageSrc: null,
      isDesktop: isDesktop(),
      viewportWidth: getViewPortWidth(),
      viewportHeight: getViewPortHeight(),
      descriptionListData: [
        {
          header: LIB.last_edited,
          values: [moment(props.data.date).format("D MMM YYYY")],
        },
      ],
      useImageFade: false,
    }

    this.getImageWidth = this.getImageWidth.bind(this)
    this.getImageHeight = this.getImageHeight.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onImageLoaded = this.onImageLoaded.bind(this)
    this.onResize = this.onResize.bind(this)
  }

  componentDidMount() {
    this.resetText()

    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onResize)
    loadImage(this.props.data.image_url, this, this.onImageLoaded)

    this.setState({
      viewportHeight: getViewPortHeight(),
    })

    setTimeout(() => {
      this.enterText()
    }, FrameAnimation.ENTER_DELAY / 3)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onResize)
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentRoute.id !== prevProps.currentRoute.id) {
      this.setState(
        {
          imageSrc: null,
          loadingImage: Boolean(this.props.data.image_url),
        },
        () => {
          if (this.props.data.image_url) {
            loadImage(this.props.data.image_url, this, this.onImageLoaded)
          }
        }
      )

      this.resetText()
      this.enterText()
    }
  }

  getImageWidth() {
    return this.nodeImageDesktop
      ? this.nodeImageDesktop.getBoundingClientRect().width
      : 600
  }

  getImageHeight() {
    return this.nodeImageDesktop
      ? this.nodeImageDesktop.getBoundingClientRect().height
      : 600
  }

  onImageLoaded(image) {
    this.setState({
      loadingImage: false,
      useImageFade: image.width > image.height,
    })
  }

  onResize() {
    if (!this.nodeSection || this.state.viewportWidth === getViewPortWidth())
      return

    this.setState({
      isDesktop: isDesktop(),
      viewportWidth: getViewPortWidth(),
      viewportHeight: getViewPortHeight(),
    })
  }

  onScroll() {
    if (!this.nodeSection) return
    const pageY = window.pageYOffset

    const offsetY = Math.max(pageY / 8, -600)
    const imageOpacity = this.state.useImageFade
      ? Math.max(1 - pageY / 800, 0)
      : 1

    this.setState({
      offsetY: offsetY,
      imageOpacity: imageOpacity,
    })
  }

  resetText() {
    if (this.nodeCat)
      window.TweenLite.set(this.nodeCat, {
        opacity: 0,
        transform: "translateX(20px)",
      })
    if (this.nodeHead)
      window.TweenLite.set(this.nodeHead, {
        opacity: 0,
        transform: "translateX(20px)",
      })
    if (this.nodeCTAs)
      window.TweenLite.set(this.nodeCTAs, {
        opacity: 0,
        transform: "translateX(20px)",
      })
  }

  enterText() {
    const time = 0.9
    const del = "-=.4"
    // eslint-disable-next-line
    const tl = new TimelineLite()
    tl.stop()
    if (this.nodeCat)
      tl.add(
        window.TweenLite.to(this.nodeCat, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    if (this.nodeHead)
      tl.add(
        window.TweenLite.to(this.nodeHead, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    if (this.nodeCTAs)
      tl.add(
        window.TweenLite.to(this.nodeCTAs, time, {
          opacity: 1,
          transform: "translateX(0)",
        }),
        del
      )
    window.TweenLite.to(tl, 1.5, { progress: 1 })
  }

  render() {
    const { currentRoute = {} } = this.props
    const { name: subBrand } = currentRoute.section || {}

    const {
      category,
      header_bold,
      header_light,
      sub_header,
      cta_primary,
      cta_secondary,
      colors,
      hide_publishing_date,
      image_url,
      url,
      video,
    } = this.props.data

    const {
      loadingImage,
      imageSrc,
      isDesktop,
      offsetY,
      imageOpacity,
      viewportWidth,
      viewportHeight,
      descriptionListData,
    } = this.state

    const showAuthorNoImage = !hide_publishing_date && !image_url

    const iPadProVertical = isDesktop && viewportHeight > viewportWidth
    const isGuide = isSMKGuide(currentRoute)

    const stylesHero = {
      color: isGuide
        ? "#ffffff"
        : colors && colors.foreground
        ? colors.foreground
        : "",
      minHeight: !image_url || iPadProVertical ? "auto" : "",
      height:
        !isDesktop && image_url && !iPadProVertical
          ? isGuide
            ? viewportHeight * 0.6
            : viewportHeight
          : "auto",
    }

    const stylesContent = {
      transform: `translateY(${offsetY}px)`,
      minHeight: !image_url || iPadProVertical ? "auto" : "",
      height:
        !isDesktop && image_url && !iPadProVertical
          ? isGuide
            ? viewportHeight * 0.6
            : viewportHeight
          : "",
    }

    const factor = 1 - imageOpacity

    const styleImage = {
      opacity: imageOpacity,
      transform: `translateY(${-(factor * factor) * 250}px)`,
    }

    const cssHero = [
      image_url ? styles.HeroArticle : styles.HeroArticleNoImage,
      isGuide && styles.subBrand_Guide,
    ].join(" ")

    const videoId = video && video.video_id

    const desktopHero = videoId ? (
      <HeroVideoPlayer video={video} />
    ) : (
      <img
        ref={(node) => (this.nodeImageDesktop = node)}
        src={imageSrc}
        className={imageSrc ? styles.inlineImageLoaded : styles.inlineImage}
        style={styleImage}
        alt={header_bold}
      />
    );

    const mobileHero = videoId ? (
      <HeroVideoPlayer video={video} />
    ) : (
      <div
        style={{
          backgroundImage: imageSrc ? `url(${imageSrc})` : "",
        }}
        className={imageSrc ? styles.imageMobileLoaded : styles.imageMobile}
      />
    );

    return (
      <React.Fragment>
        <section
          ref={(node) => (this.nodeSection = node)}
          className={cssHero}
          style={stylesHero}
        >
          <div
            className={styles.imageInlineContainer}
            style={{ opacity: loadingImage ? 0 : 1 }}
          >
            {isDesktop ? desktopHero : mobileHero}
          </div>

          <article className={styles.contentArticle} style={stylesContent}>
            <div className={`container-fluid ${styles.frontContainerFluid}`}>
              <div className="row">
                <div className="col-xs-11 col-md-5">
                  <CategoryOrSubBrand
                    ref={(node) => (this.nodeCat = node)}
                    category={category}
                    subBrand={subBrand}
                    url={url}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-xs-11 col-md-5">
                  {currentRoute.type === "audio_guide" && (
                    <div>{LIB.audio_guide}</div>
                  )}
                  <HeaderBoldLightSub
                    ref={(node) => (this.nodeHead = node)}
                    header_bold={header_bold}
                    header_light={header_light}
                    header_sub={sub_header}
                  />
                </div>
                {showAuthorNoImage && (
                  <div className="col-xs-11 col-md-offset-1 col-md-5">
                    <DescriptionListsContainer items={descriptionListData} />
                  </div>
                )}
              </div>

              {image_url && (
                <div className="row">
                  {Boolean(
                    Boolean(cta_primary && cta_primary.url) ||
                      Boolean(cta_secondary && cta_secondary.url)
                  ) && (
                    <div className="col-xs-11 col-md-5">
                      <CTAs
                        ref={(node) => (this.nodeCTAs = node)}
                        cta_primary={cta_primary}
                        cta_secondary={cta_secondary}
                        cta_title={header_bold}
                      />
                    </div>
                  )}
                </div>
              )}

              {!image_url &&
                Boolean(
                  Boolean(cta_primary && cta_primary.url) ||
                    Boolean(cta_secondary && cta_secondary.url)
                ) && (
                  <div className="row">
                    <div className="col-xs-11 col-md-5">
                      <CTAs
                        ref={(node) => (this.nodeCTAs = node)}
                        cta_primary={cta_primary}
                        cta_secondary={cta_secondary}
                        cta_title={header_bold}
                      />
                    </div>
                  </div>
                )}
            </div>
          </article>
        </section>

        {!hide_publishing_date && image_url && (
          <RichText>
            <DescriptionListsContainer items={descriptionListData} />
          </RichText>
        )}
      </React.Fragment>
    )
  }
}


export default withRouter(HeroArticle)



// WEBPACK FOOTER //
// ./src/components/Hero/HeroArticle.js